<template>
  <div class="product__sticky-title" :class="{ 'is-visible': isVisible }">
    <h2 class="h4" v-html="title"></h2>
  </div>
</template>

<script>
export default {
  name: 'StickyProductTitle',
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isVisible: false
    }
  },
  mounted() {
    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll(); // Check initial state
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const mainTitle = document.querySelector('.product__header h1');
      const gallery = this.$el.parentElement;
      
      if (mainTitle) {
        const mainTitleRect = mainTitle.getBoundingClientRect();
        const shouldShow = mainTitleRect.bottom <= 0;
        
        this.isVisible = shouldShow;
        
        // Add/remove class to gallery container
        if (shouldShow) {
          gallery.classList.add('has-sticky-title');
        } else {
          gallery.classList.remove('has-sticky-title');
        }
      }
    }
  }
}
</script> 